import { render, staticRenderFns } from "./VuegramPost.vue?vue&type=template&id=c4c9b33e&"
import script from "./VuegramPost.vue?vue&type=script&lang=js&"
export * from "./VuegramPost.vue?vue&type=script&lang=js&"
import style0 from "../styles/vuegram-post.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports